import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import {Helmet} from "react-helmet";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { MdQuestionAnswer, MdCallSplit, MdOutlineArrowLeft, MdAdd } from "react-icons/md";

import Main from "./Main";
import { AppContext } from "../../Context";
import { Config } from "../../inc/Config";
import Fetch, { Loader, dateToText, GET } from "../../inc/Fetch";
import { Img } from "../../components/Elements";
import BooksList from "./components/BooksList";
import Permission from "../Permission";

import './css/content.css'

export default function Content() {

    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();

    // let site = data?.cats?.filter(r => r?.name == params?.id);
    // site = site?.length ? site[0] : {};

    const { userData, siteData } = useContext(AppContext); 
    const [site, setsite] = siteData;
    const [userinfo, setuserinfo] = userData;
    
    let catID = site?.cats?.filter(r => r?.name == params?.id);
    catID = catID?.length ? catID[0]?._id : false;
    
    async function loadData() {
        let res = await GET(`content/view_one?_id=${params?._id}`);
        return res;
    }

    const { data, error, isLoading } = useQuery(`content-${params?._id}`, loadData); 
    
    if (isLoading) {
        return <Loader />
    }

    // if (userinfo?.userlevel < 3) {
    //     return <Permission />
    // }

	return (
		<>

        <Main>

            <div style={{ paddingTop:140 }}  className="mainWidth">
                
            </div>

            <div className='section4 contentBoxAll'>

                <div className="mainWidth ">
                    <nav className='breadcrumbs'>
                        <Link to={`/site/${params?.id}`}>{t("home")}</Link>
                        <MdOutlineArrowLeft />
                        <Link>{data?.content?.title}</Link>
                    
                    </nav>
                    
                    <div style={{marginTop:20}} className='mainSectionBox inside'>
                        <div>
                            <h1>{data?.content?.title}</h1>
                            <hr />
                        </div>

                        
                    </div>

                    <div className='fullTextBox' dangerouslySetInnerHTML={{ __html:data?.content?.full }} />


                </div>
            </div>

         
        </Main>

		</>
	)
}
